import Icon from '../components/Icon.vue'

Icon.register({
  'file-excel': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM284.1 242.5L224 336 284.1 429.5C289.2 437.5 283.5 448 274 448H239.1C234.7 448 230.6 445.6 228.5 441.7 208.9 405.5 192 373 192 373 185.6 387.8 182 393 155.4 441.8 153.3 445.7 149.3 448.1 144.9 448.1H110C100.5 448.1 94.8 437.6 99.9 429.6L160.2 336.1 99.9 242.6C94.7 234.6 100.5 224.1 110 224.1H144.8C149.2 224.1 153.3 226.5 155.4 230.4 181.5 279.2 175.4 264 192 298.9 192 298.9 198.1 287.2 228.6 230.4 230.7 226.5 234.8 224.1 239.2 224.1H274C283.5 224 289.2 234.5 284.1 242.5zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-excel.js
// module id = duak
// module chunks = 144